<script setup>
import { Link, usePage } from '@inertiajs/vue3';
const $page = usePage();
</script>

<template>
    <Link :href="'/'">
        <img :src="$page.props.platform_brand.logo" alt="Logo" class="h-auto w-full">
    </Link>
</template>
